export default async function taktikalStart(phoneNumber, id = null) {
  try {
    let url = id ? `/api/taktikalstart/${id}` : `/api/taktikalstart`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        phone: phoneNumber
      })
    });

    if (!response.status || response.status >= 400) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error in taktikalSSN:', error);
    return error;
  }
}

export async function taktikalPoll(authRequestId, id) {
  try {
    const response = await fetch(`/api/taktikalpoll/${id}`, {
      timeout: 180000,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        authRequestId: authRequestId
      })
    });
    if (!response.status || response.status >= 404) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response;
  } catch (error) {
    console.error('Error in taktikalSSN:', error);
    return error;
  }
}

export async function taktikalSignin(authRequestId) {
  try {
    const response = await fetch(`/api/taktikalsignin`, {
      timeout: 180000,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        authRequestId: authRequestId
      })
    });
    if (!response.status || response.status >= 404) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response;
  } catch (error) {
    console.error('Error in taktikalSSN:', error);
    return error;
  }
}
